if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

// --- DYNAMIC WHATSAPP TOGGLE METHOD ---
      toggleSubmitButton(disable = true, text) {
        const waBtn = this.querySelector('.dynamic-wa-btn');
        const dynamicCheckout = this.querySelector('.dynamic-checkout-wrapper'); 

        if (disable && text === window.variantStrings.soldOut) {
          
          // 1. Hide Standard Cart Elements
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.style.display = 'none';
          if (dynamicCheckout) dynamicCheckout.style.display = 'none';

          // 2. Reveal WhatsApp Button & Update URL Context
          if (waBtn) {
            waBtn.style.display = 'flex';
            
            const titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
            const productTitle = titleEl ? titleEl.innerText.trim() : '';
            
            let variantTitle = '';
            const selectedVariant = document.querySelector('variant-selects [data-selected-variant]');
            if (selectedVariant) {
              try { variantTitle = JSON.parse(selectedVariant.innerHTML).title; } catch(e){}
            }
            const fullName = variantTitle ? `${productTitle} - ${variantTitle}` : productTitle;
            
            let waNumber = '440000000000';
            if (window.Shopify && window.Shopify.country === 'PK') waNumber = '923210859995';
            else if (window.Shopify && window.Shopify.country === 'GB') waNumber = '447577506388';

            const msg = `Hi, I saw that ${fullName} is sold out. Can you let me know when it will be back in stock?`;
            waBtn.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}`;
          }

        } else if (disable) {
          // Standard Unavailable State (e.g., missing variant)
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
          
          this.submitButton.style.display = '';
          if (dynamicCheckout) dynamicCheckout.style.display = 'none';
          if (waBtn) waBtn.style.display = 'none';

        } else {
          // In Stock / Made To Order State
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
          
          this.submitButton.style.display = '';
          if (dynamicCheckout) dynamicCheckout.style.display = '';
          if (waBtn) waBtn.style.display = 'none';
        }
      }
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
